<template>
    <form
        @submit.prevent="submit"
        :action="url"
        method="post"
        class="card space-y-4"
    >
        <p class="text-lg text-gray-600">Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you didn't receive the email, we will gladly send you another.</p>
        <loading-button
            :loading="form.processing"
            class="btn btn-green w-full sm:w-auto sm:ml-auto"
        >
            Send Email
        </loading-button>
    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'
import { useNotificationStore } from '@/stores/notification'

const props = defineProps({
    url: {
        type: String,
        required: true,
    }
})

const notification = useNotificationStore()

const form = useForm({})

const submit = () => {
    notification.clear()
    form.post(props.url, {
        onSuccess: () => notification.set({
            'body': 'A new verification link has been sent to the email address you provided during registration.',
            'type': 'modal',
            'heading': 'Check Your Email',
        })
    })
}
</script>
